const BASIC_ATTRIBUTES = {
    "label" : "http://www.w3.org/2000/01/rdf-schema#label",
    "prefLabel" : "http://www.w3.org/2000/01/rdf-schema#label",
    "altLabel" : "http://www.w3.org/2004/02/skos/core#altLabel",
    "comment" : "http://www.w3.org/2000/01/rdf-schema#comment",
    "definition" : "http://www.w3.org/2004/02/skos/core#definition",
    "notation" : "http://www.w3.org/2004/02/skos/core#notation",
};

export default BASIC_ATTRIBUTES;